import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApiVisa,
  BranchLocationLinkService,
  BranchService,
  LocationContainerModel,
  LocationService,
  Pagination,
} from 'blg-akaun-ts-lib';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'blg-select-location-drop-down-stock',
  templateUrl: './select-location-drop-down-stock.component.html',
  styleUrls: ['./select-location-drop-down-stock.component.css'],
})
export class SelectLocationDropDownStockComponent implements OnInit {
  @Input() location = new FormControl(null, Validators.required);
  @Input() apiVisa: ApiVisa;
  @Input() required: boolean;
  @Input() label = 'Location';
  @Input() locationGuids: any[];

  @Output() locationChange = new EventEmitter<FormControl>();
  @Output() locationSelected = new EventEmitter<LocationContainerModel>();

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<LocationContainerModel[]> = new ReplaySubject<
    LocationContainerModel[]
  >(1);
  locationList: LocationContainerModel[] = [];
  selectedLocation = new LocationContainerModel();
  locations: any = [];

  protected _onDestroy = new Subject<void>();
  unlinkedLocation: boolean;

  constructor(
    private lctnService: LocationService
  ) {}

  ngOnInit() {
    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LocationFiltering();
      });

    // load the initial location list
    this.getAllLocations();
    this.location.markAsTouched();
  }

  ngOnChanges() {
    this.getAllLocations();
  }

  getAllLocations() {
    //empty the prev list when selected branch changed
    this.filteredOptions$.next(null);

    let pagination = new Pagination();
    pagination.limit = 1000;

    if (this.locationGuids.length > 0) {
      pagination.conditionalCriteria.push({
        columnName: 'hdr_guids',
        operator: '=',
        value: this.locationGuids.toString(),
      });
    }
    this.lctnService.getByCriteria(pagination, this.apiVisa).subscribe((x) => {
      this.locationList = [];
      this.locations = [];
      x.data.forEach((data) => {
        this.locations.push(data);
        this.locationList.push(data);
      });
      // sorting
      const sorted = this.locations.sort((a, b) =>
        a.bl_inv_mst_location.code < b.bl_inv_mst_location.code ? -1 : 1
      );
      //fill the drop down
      this.filteredOptions$.next(this.locations.slice());
    });
  }

  LocationFiltering() {
    if (!this.locations) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.locations.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the locations
    this.filteredOptions$.next(
      this.locations.filter(
        (option) =>
          (option.bl_inv_mst_location.code
            ? option.bl_inv_mst_location.code.toLowerCase().indexOf(search) > -1
            : null) ||
          (option.bl_inv_mst_location.name
            ? option.bl_inv_mst_location.name.toLowerCase().indexOf(search) > -1
            : null)
      )
    );
  }

  onSelect(locationGuid: string) {
    if (locationGuid) {
      this.location.patchValue(locationGuid);
      this.selectedLocation = this.locationList.find(
        (lctn) => lctn.bl_inv_mst_location.guid === locationGuid
      );
      this.locationSelected.emit(this.selectedLocation);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
